import { render, staticRenderFns } from "./ForgerPasswordPage.vue?vue&type=template&id=3fe606c8&scoped=true"
import script from "./ForgerPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgerPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ForgerPasswordPage.vue?vue&type=style&index=0&id=3fe606c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe606c8",
  null
  
)

export default component.exports